import { __rest } from "tslib";
import * as React from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import cn from 'classnames';
import { ThemeProvider, useTheme } from '../../../../../../theme';
import { CardExtraView } from '../CardExtraView';
import { CdnIcon, SafeHtml } from '@shared/ui';
const CardExtraViewAggregator = (_a) => {
    var { icon, title, description, headerIcons, headerControls, content, onAdd, onDelete } = _a, props = __rest(_a, ["icon", "title", "description", "headerIcons", "headerControls", "content", "onAdd", "onDelete"]);
    const { CardExtraViewAggregator: theme } = useTheme('Shared').CardExtraView;
    const descriptionContent = description && typeof description === 'string' ? (React.createElement(SafeHtml, { className: theme.description, html: description })) : (React.createElement("div", { className: theme.description }, description));
    const isSelected = !onAdd || !!onDelete;
    return (React.createElement(ThemeProvider, { value: {
            Shared: {
                CardExtraView: { CardExtraView: theme }
            }
        } },
        React.createElement(CardExtraView, Object.assign({}, props, { icon: React.createElement(React.Fragment, null), headerControls: React.createElement(React.Fragment, null,
                headerControls,
                (headerIcons === null || headerIcons === void 0 ? void 0 : headerIcons.length) > 0 && (React.createElement("div", { className: theme.icons }, headerIcons.map(icon => (React.createElement(CdnIcon, { key: icon, icon: icon }))))),
                React.createElement(ButtonBase, { className: cn(theme.buttonStatus, { [theme.buttonStatus_selected]: isSelected }), "aria-hidden": "false" },
                    React.createElement(CdnIcon, { icon: isSelected ? 'Info/Check' : 'Action/Add' }))), content: React.createElement(React.Fragment, null,
                React.createElement("div", { className: theme.title }, title), content !== null && content !== void 0 ? content : descriptionContent), onClick: onAdd }))));
};
export default CardExtraViewAggregator;
